<template>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="registration-title" v-if="Account.IsCoveredUnderHIPAA">
          Terms & Conditions and BAA
        </div>
        <p v-if="Account.IsCoveredUnderHIPAA" class="g-mb-0">
          <small
            >Please review and accept the below in connection with your
            registration and participation in the OneSight EssilorLuxottica
            Foundation's Champions for Sight® program: (i) Terms and Conditions
            to the Changing Life through Lenses® Agreement (related to the
            online charitable glasses and resources tool), (ii) Business
            Associate Agreement (“BAA”) (collectively, the "Champions for Sight®
            Contract"), and (iii) Terms and Conditions to the Grateful Patient™
            Point of Sale Giving Agreement (related to the point of sale giving
            campaign tool).</small
          >
          <!--<a class="g-font-size-18" href="https://drive.google.com/open?id=11aAdDDi7-v4nLW7SLlZZDgSaawsBaAxo" target="_blank">click here</a> to download a copy.
                    <!-- <a href="../../../../static/download/EVF PORTAL TERMS AND CONDITIONS.pdf" download="EVF Portal Terms and Conditions">Click here</a> to download a PDF version of this document for your records. -->
        </p>
        <p v-if="!Account.IsCoveredUnderHIPAA" class="g-mb-0">
          Please review and accept the below Terms and Conditions or
          <a
            class="g-font-size-18"
            href="https://drive.google.com/open?id=1DcjwlGpVIiO25W09ai5eVpA8qt-ApTRN"
            target="_blank"
            >click here</a
          >
          to download a copy.
          <!-- <a href="../../../../static/download/EVF PORTAL TERMS AND CONDITIONS.pdf" download="EVF Portal Terms and Conditions">Click here</a> to download a PDF version of this document for your records. -->
        </p>
        <div class="terms-style">
          <div class="terms-section">
            Changing Life through Lenses® Agreement
          </div>
          <p style="margin-top: 0pt; margin-bottom: 4pt; text-align: justify">
            <strong>Changing Life through Lenses® Terms and Conditions</strong>
          </p>
          <ol type="1" style="margin: 0pt; padding-left: 0pt">
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                padding-left: 3.83pt;
              "
            >
              <strong>Contract Documents and</strong>
              <strong>Effective Date:</strong> These Changing Life through
              Lenses® Terms and Conditions ("<strong
                >Terms and Conditions</strong
              >") supplement and are made a part of the Changing Life through
              Lenses® Agreement ("<strong>Contract</strong>") by and between the
              legal entity or individual identified as the participant
              (“<strong>Participant</strong>”) on the Champions for Sight®
              registration form (“<strong>Registration Form</strong>”) and
              OneSight d/b/a OneSight EssilorLuxottica Foundation
              ("<strong>Foundation”</strong>). The Contract consists of (i)
              these Terms and Conditions, and (ii) if applicable, the Business
              Associate Agreement (which is set forth on the Registration Form
              if Participant is a covered entity<span
                style="letter-spacing: 0.1pt; color: #444444"
              >
              </span
              ><span style="letter-spacing: 0.1pt">under the </span>Health
              Insurance Portability and Accountability Act of 1996).&#xa0; Your
              use of the Changing Life through Lenses® online platform
              (“<strong>Portal</strong>”) is also subject to the
              <a
                href="https://www.evfusa.org/terms-and-conditions/"
                target="_blank"
                style="text-decoration: none"
                ><u><span style="color: #467886">Terms of Use</span></u></a
              >
              and
              <a
                href="https://www.evfusa.org/privacy-policy/"
                target="_blank"
                style="text-decoration: none"
                ><u><span style="color: #467886">Privacy Policy</span></u></a
              >
              posted on
              <a
                href="http://www.championsforsight.org"
                style="text-decoration: none"
                ><u
                  ><span style="color: #467886"
                    >www.championsforsight.org</span
                  ></u
                ></a
              >; provided, that in the event of any conflict between the
              Contract and the
              <a
                href="https://www.evfusa.org/terms-and-conditions/"
                target="_blank"
                style="text-decoration: none"
                ><u><span style="color: #467886">Terms of Use</span></u></a
              >
              and/or
              <a
                href="https://www.evfusa.org/privacy-policy/"
                target="_blank"
                style="text-decoration: none"
                ><u><span style="color: #467886">Privacy Policy</span></u></a
              >, the provisions of the Contract shall prevail. Capitalized terms
              used but not defined in these Terms and Conditions shall have the
              meaning ascribed to them in the Registration Form.&#xa0; If you
              accept the Contract, the date on which you click the “Agree &amp;
              Submit” or similar button shall be the effective date of the
              Contract (“<strong>Effective Date</strong>”).
              <u
                >BY CLICKING THE “SUBMIT” BUTTON, (i) YOU ARE BINDING
                PARTICIPANT TO THE CONTRACT, THE </u
              ><a
                href="https://www.evfusa.org/terms-and-conditions/"
                target="_blank"
                style="text-decoration: none"
                ><u><span style="color: #467886">TERMS OF USE</span></u></a
              ><u>, AND THE </u
              ><a
                href="https://www.evfusa.org/privacy-policy/"
                target="_blank"
                style="text-decoration: none"
                ><u><span style="color: #467886">PRIVACY POLICY</span></u></a
              ><u
                >, AND (ii) IF PARTICIPANT IS A LEGAL ENTITY, YOU ARE
                REPRESENTING AND WARRANTING THAT YOU ARE AUTHORIZED TO AGREE TO
                THE CONTRACT, THE </u
              ><a
                href="https://www.evfusa.org/terms-and-conditions/"
                target="_blank"
                style="text-decoration: none"
                ><u><span style="color: #467886">TERMS OF USE</span></u></a
              ><u>, AND THE </u
              ><a
                href="https://www.evfusa.org/privacy-policy/"
                target="_blank"
                style="text-decoration: none"
                ><u><span style="color: #467886">PRIVACY POLICY</span></u></a
              ><u> ON BEHALF OF PARTICIPANT</u>.<u> </u>
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                padding-left: 3.83pt;
              "
            >
              <strong>Program Information:</strong> The Foundation is a
              non-profit organization committed to eliminating poor vision and
              its lifelong consequences and to providing underprivileged people
              the opportunity to live a better life through better sight. The
              Foundation works with nonprofit organizations and socially
              responsible vision care providers across the United States to
              provide in-kind donations of lenses and manufacturing of glasses
              for use by Eligible Patients (the “<strong>CLTL Program</strong
              >”).&#xa0; “<strong>Eligible Patients</strong>” are individuals
              (i) living at or below the poverty line; (ii) who are not covered
              by vision insurance for the pair of glasses to be provided in
              connection with the Program; and (iii) who could not otherwise
              afford vision services, as reasonably determined by Participant.
              The Foundation has created the Portal to facilitate registration
              and participation in the CLTL Program. Participant acknowledges
              that the current focus of the CLTL Program is on youth and agrees
              to use reasonable efforts to provide products supplied by the
              Foundation (including lenses and/or frames) primarily to Eligible
              Patients who are minors.&#xa0; Participant further acknowledges
              and agrees that, upon reasonable advance notice to Participant,
              the Foundation may from time to time revise the definition of
              Eligible Patients and the criteria for determining eligibility.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                padding-left: 3.83pt;
              "
            >
              <strong>Program Materials:</strong> The Foundation will make
              available to Participant educational resources and materials
              describing how Participant may conduct and optimize its charitable
              activities in connection with the CLTL Program (“<strong
                >CLTL Program Educational Materials</strong
              >”) and may make available to Participant certain assets or
              materials to promote Participant’s involvement in the CLTL Program
              (“<strong>CLTL Program Promotional Materials</strong>”) (CLTL
              Program Educational Materials and CLTL Program Promotional
              Materials, collectively “<strong>CLTL Program Materials</strong
              >”). Participant may make copies of CLTL Program Educational
              Materials solely for use by Participant and Participant’s
              employees in connection with the CLTL Program. Participant shall
              not copy CLTL Program Promotional Materials without the
              Foundation’s express written approval. If Participant has an
              opportunity to promote the CLTL Program with CLTL Program
              Promotional Materials, upon Participant’s request, the Foundation
              will provide Participant with the Foundation logo lock up and
              graphic standards to be used, subject to the Foundation’s prior
              written approval in each instance. Participant shall use CLTL
              Program Materials solely in connection with the CLTL Program.
              Participant shall use CLTL Program Materials as is and shall not
              modify CLTL Program Materials in any way without the express
              written approval of the Foundation. Participant shall not delete,
              obscure, or alter any disclosures or any copyright notice,
              trademarks, or other proprietary rights notices affixed to or
              contained in the CLTL Program Materials. Upon expiration or
              termination of the Contract, Participant shall destroy or
              immediately return to the Foundation all CLTL Program Materials in
              Participant’s possession.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                padding-left: 3.83pt;
              "
            >
              <strong>Lenses and Frames:</strong> The Foundation will endeavor
              to provide Participant with fully fabricated lenses, subject to
              such limitations on quantity as the Foundation may determine from
              time to time in its sole discretion, as prescribed by the
              Participant for Eligible Patients served through Participant’s
              charitable activities. Lenses will be fabricated to meet the
              prescription needs of each Eligible Patient, including single
              vision and bifocals and the use of polycarbonate materials. Lenses
              shall be fabricated by the Foundation’s suppliers and mounted in
              frames provided on a frame-to-come basis by Participant (“<strong
                >Participant Frames</strong
              >”), unless Participant (i) specifies lenses only (without
              mounting) or (ii) orders a complete pair of glasses through the
              Portal, including frames supplied by the Foundation(“<strong
                >Foundation Frames</strong
              >”), if available, in which case the Foundation’s suppliers will
              fabricate and mount the lenses in such Foundation Frames. If
              Foundation Frames are available, the Foundation may, in its sole
              discretion, charge Participant a service fee for complete orders
              (lenses with Foundation Frames). In addition, a supply of
              Foundation Frames may be available for a service fee in order to
              provide sample selection for display or trial by Eligible
              Patients.&#xa0; Participant is responsible for shipping
              Participant Frames to the Foundation’s designated supplier at
              Participant’s own expense.&#xa0; Shipments of lenses and frames
              from the Foundation or its supplier to Participant will be at no
              cost to Participant.&#xa0; For clarity, the Foundation does not
              guarantee that Foundation Frames will be available.&#xa0; If
              available, The Foundation does not guarantee that colors of
              Foundation Frames as depicted online will be accurately displayed.
              The Foundation does not warrant that the Foundation Frame product
              descriptions are accurate, complete, reliable, current or
              error-free.&#xa0; The Foundation will not be liable for
              typographical errors and reserves the right to refuse or cancel
              any order or service in the event of a typographical error. The
              Foundation, in its sole discretion, shall select suppliers of CLTL
              Program products and services and Participant may not designate
              suppliers of its choice.&#xa0; The Foundation has the right to
              reduce or limit the number of lenses and/or frames made available
              under this Contract at any time for any reason.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                padding-left: 3.83pt;
              "
            >
              <strong>Warranty Disclaimer: </strong>Participant Frames may be
              lost or damaged during the fabrication of eyeglasses.
              Participant’s use of Participant Frames is at Participant’s own
              risk. The Foundation, its suppliers and service providers,
              including any laboratory used by the Foundation, shall not be
              liable for damage to the frame due to the fabrication and shipping
              process or for lost frames. <strong>&#xa0;</strong
              ><strong
                >THE PORTAL, ALL LENSES AND FRAMES, AND ALL RELATED SERVICES ARE
                PROVIDED ON AN "AS IS" BASIS, WITH ALL FAULTS AND WITHOUT
                WARRANTY OF ANY KIND.</strong
              ><strong>&#xa0; </strong
              ><strong
                >THE FOUNDATION HEREBY DISCLAIMS ALL WARRANTIES OF ANY KIND WITH
                RESPECT TO THE PORTAL, THE LENSES AND FRAMES, AND RELATED
                SERVICES, WHETHER EXPRESS, IMPLIED, OR STATUTORY, INCLUDING THE
                IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
                PURPOSE, QUIET ENJOYMENT, TITLE, AND NON-INFRINGEMENT, AND
                WARRANTIES ARISING THROUGH COURSE OF DEALING OR USAGE OF
                TRADE.</strong
              ><strong>&#xa0; </strong>
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                padding-left: 3.83pt;
              "
            >
              <strong>Additional Foundation Responsibilities:</strong>
              Participant agrees that the Foundation may, but is not obligated
              to, list Participant as a CLTL Program participant on the
              Foundation website in the same manner it lists other comparable
              CLTL Program participants. The Foundation will submit to
              Participant any requests for additional trademarks, copy or
              content needed for individual events or media for the
              Participant’s approval prior to publication.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                padding-left: 3.83pt;
              "
            >
              <strong>Participant Responsibilities: </strong
              ><em
                >In the event that Participant fails to satisfy one or more of
                the below-referenced responsibilities, or any other Participant
                obligation set forth in the Contract, the Foundation may, in its
                sole discretion, offer to modify the terms of this Contract in
                lieu of other recourse.</em
              >
            </li>
          </ol>
          <p
            style="
              margin-top: 0pt;
              margin-left: 36pt;
              margin-bottom: 0pt;
              text-indent: -18pt;
              text-align: justify;
            "
          >
            ●<span style="display: inline-block"
              >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
            ><strong
              >Participant agrees to promote the Foundation as a charitable
              sponsor and to co-brand any marketing or promotional materials
              prepared by Participant related to Participant’s charitable
              services in connection with the CLTL Program, provided that
              Participant agrees to submit to The Foundation Any such co-branded
              materials, including copy or content for individual events or
              media, for the Foundation’s written approval prior to publication
              or other distribution. Participant will not use the Foundation
              name, logo or other intellectual property without the prior
              written approval of the Foundation.</strong
            >
          </p>
          <p
            style="
              margin-top: 0pt;
              margin-left: 36pt;
              margin-bottom: 0pt;
              text-indent: -18pt;
              text-align: justify;
            "
          >
            ●<span style="display: inline-block"
              >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
            ><strong
              >Participant agrees to use the CLTL Program, and any lenses,
              frames, and related services ordered through the Portal or ordered
              in connection with the CLTL Program solely for charitable vision
              services to Eligible Patients and to validate patient eligibility
              in accordance with criteria established by the Foundation from
              time to time.</strong
            >
          </p>
          <p
            style="
              margin-top: 0pt;
              margin-left: 36pt;
              margin-bottom: 0pt;
              text-indent: -18pt;
              text-align: justify;
            "
          >
            ●<span style="display: inline-block"
              >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
            ><strong
              >Participant agrees that Participant will not charge Eligible
              Patients for the lens product delivered; however, Participant may
              charge Eligible Patients up to, but not to exceed, the actual cost
              of the frame paid by Participant.
            </strong>
          </p>
          <p
            style="
              margin-top: 0pt;
              margin-left: 36pt;
              margin-bottom: 0pt;
              text-indent: -18pt;
              text-align: justify;
            "
          >
            ●<span style="display: inline-block"
              >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
            ><strong
              >Participant agrees to retain an Electronic Health Record (EHR) or
              an electronic log containing, at a minimum, the following
              information:</strong
            ><strong>&#xa0; </strong
            ><strong
              >for each Eligible Patient, the date of service, number/name of
              patient examined, and how eligibility was validated; the number of
              exams provided; the number of Eligible Patients who received
              glasses; the number of glasses dispensed; and the number of
              Eligible Patients receiving glasses for the first time. The
              electronic log must be kept current and made available to the
              Foundation as the Foundation may request from time to time during
              the Term (as defined below) and for one year thereafter for audit
              purposes and other treatment and health care operation purposes
              further described in any applicable Business Associate Agreement.
            </strong>
          </p>
          <ol start="8" type="1" style="margin: 0pt; padding-left: 0pt">
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                padding-left: 3.83pt;
              "
            >
              <strong>Marks:</strong> Participant acknowledges the Foundation’s
              right, title, and interest in its trade names, trademark, trade
              dress, logos, and other indicia of origin owned or licensed by the
              Foundation (the “<strong>the Foundation Marks</strong>”).
              Participant is authorized to use the Foundation Marks solely as
              the Foundation Marks are incorporated into the CLTL Program
              Materials or as otherwise approved by the Foundation in writing in
              connection with the CLTL Program and shall not use the Foundation
              Marks for any other purpose. Participant acknowledges and agrees
              that the Foundation or its licensor, as applicable, retains all
              ownership rights in the Foundation Marks and that the benefit of
              use of the Foundation Marks hereunder, as well as all trademark
              and other intellectual property rights stemming therefrom, shall
              inure and belong solely to the Foundation or its licensor, as
              applicable. Participant agrees to cease use of the Foundation
              Marks immediately upon the Foundation’s request or termination of
              this Contract. Participant will not attempt to obtain a copyright
              or trademark in any artwork that contains or is derived from the
              Foundation Marks without the Foundation’s prior written consent.
              Participant grants to the Foundation a limited, non-exclusive
              license to use the Participant name and logo, together with the
              brand names, logos, and images otherwise provided or authorized by
              Participant, (the “Participant Marks”) for the sole purpose of
              promoting the CLTL Program and acknowledging Participant’s
              participation in the CLTL Program; provided, however, that any
              other use by the Foundation of intellectual property rights owned
              by Participant requires Participant’s prior written authorization.
              Upon request, Participant shall provide the Foundation with high
              resolution images of Participant’s logo.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                padding-left: 3.83pt;
              "
            >
              <strong>No Endorsement:</strong> Participant shall in no way
              suggest endorsement by the Foundation of Participant or
              Participant’s products or services.
            </li>
            <li style="margin-left: 36pt; text-align: justify">
              <strong>Permission to Link:</strong> During the Term, (i) the
              Foundation grants Participant permission to provide a link from
              Participant’s Web site to the Foundation’s Web site, which
              permission the Foundation may withdraw at any time and for any
              reason; and (ii) Participant grants the Foundation permission to
              provide a link from the Foundation’s Web site to Participant’s Web
              site, which permission Participant may withdraw at any time and
              for any reason. Neither party shall have an obligation to provide
              a link from its Web site to the Web site of the other party.
            </li>
            <li style="margin-left: 36pt; text-align: justify">
              <strong>Representations and Warranties of the Foundation:</strong>
              The Foundation represents and warrants to Participant that it has
              the right, power, and authority to enter into this Contract.
            </li>
            <li style="margin-left: 36pt; text-align: justify">
              <strong>Representations and Warranties of Participant:</strong>
              Participant represents and warrants to the Foundation that: (i) it
              has the right, power, and authority to enter into this Contract;
              (ii) it will comply with all applicable federal, state, and local
              laws, statutes, ordinances, and regulations (collectively,
              “<strong>Laws</strong>”) in connection with the CLTL Program and
              this Contract, including Laws related to professional licensure
              and the provision of vision care services; and (iii) any valid
              lens prescription ordered before expiration date noted on the
              prescription submitted by Participant have been prescribed by duly
              licensed professionals.
            </li>
            <li style="margin-left: 36pt; text-align: justify">
              <strong>Indemnity:</strong> Participant agrees to indemnify and
              hold the Foundation, its suppliers, and each of their directors,
              officers, employees, agents, representatives, and volunteers,
              harmless from and against any and all costs, losses, and expenses,
              including reasonable attorneys’ fees, that the Foundation may
              incur by reason of any claims, actions, demands, or law suits
              brought by a third party arising out of, or in connection with (i)
              Participant’s negligence, recklessness, or intentional misconduct;
              (ii) Participant’s performance or failure to perform pursuant to
              this Contract, including breach of any provision of this Contract;
              or (iii) Participant’s location(s), business, products, or
              services, including any claims in the nature of product liability,
              personal injury, or professional malpractice.
            </li>
            <li style="margin-left: 36pt; text-align: justify">
              <strong>Term and Termination:</strong> This Contract shall
              commence on the Effective Date and will continue until terminated
              in accordance herein (the “<strong>Term</strong>”). Unless
              otherwise mutually agreed by the parties, the Contract shall
              automatically terminate upon the termination of any applicable
              Business Associate Agreement. Either party may terminate this
              Contract: (i) upon any material breach of the Contract by the
              other party, if such breach is not remedied to the reasonable
              satisfaction of the non-breaching party within fifteen (15) days
              after the non-breaching party provides written notice of the
              breach to the other party; (ii) immediately upon written notice to
              the other party whenever the notifying party in its reasonable
              discretion determines that the continuation of the Contract will
              damage its reputation or good will; or (iii) upon fifteen (15)
              days written notice for convenience. In addition, the Foundation
              may terminate the Contract (i) immediately upon written notice to
              Participant in the event the Foundation discontinues the CLTL
              Program, or (ii) if the Foundation revises the Contract or any
              portion thereof (including provisions of the Terms and Conditions
              and/or, if applicable, the Business Associate Agreement) and
              Participant does not agree to the revised Contract within the time
              allowed by the Foundation.&#xa0; Upon termination of this
              Contract, Participant shall immediately (A) cease to use the CLTL
              Program Materials and the Foundation Marks, (B) discontinue any
              new orders (The Foundation will honor any orders for lenses or the
              fabrication of lenses received prior to the effective date of
              termination), (C) discontinue references in any manner to its
              relationship with the Foundation, and (D) retain the electronic
              audit log referenced in Section 7 above for one year following
              termination of the Contract. For purposes of this Section 14,
              Participant’s breach of any of Participant’s obligations set forth
              in Section 7 above shall be deemed a material breach of this
              Contract. The provisions of this Section shall not preclude the
              parties from seeking any other remedies available to them under
              this Contract and applicable law. The Sections regarding Warranty
              Disclaimer, Indemnity, Governing Law and Venue, Limitation of
              Liability, Notices, and Miscellaneous shall survive termination of
              this Contract. In addition, any provision which would, by its
              nature, survive the termination of this Contract, shall do so.
            </li>
          </ol>
          <ol start="15" type="1" style="margin: 0pt; padding-left: 0pt">
            <li style="margin-left: 36pt; text-align: justify">
              <strong>Disputes; Governing Law and Venue:</strong>
              <strong
                ><u
                  >Any disputes between the parties related to the Contract, the
                  CLTL Program, or the Portal shall be governed by the “Disputes
                  with OneSight EssilorLuxottica Foundation” section of the
                </u></strong
              ><a
                href="https://www.evfusa.org/terms-and-conditions/"
                target="_blank"
                style="text-decoration: none"
                ><strong
                  ><u
                    ><span style="color: #467886">Terms of Use</span></u
                  ></strong
                ></a
              ><strong
                ><u
                  >, including, to the extent applicable, the Agreement to
                  Arbitrate set forth in the “Disputes with OneSight
                  EssilorLuxottica Foundation” section of the
                </u></strong
              ><a
                href="https://www.evfusa.org/terms-and-conditions/"
                target="_blank"
                style="text-decoration: none"
                ><strong
                  ><u
                    ><span style="color: #467886">Terms of Use</span></u
                  ></strong
                ></a
              ><u>.</u> If and to the extent the
              <a
                href="https://www.evfusa.org/terms-and-conditions/"
                target="_blank"
                style="text-decoration: none"
                ><u><span style="color: #467886">Terms of Use</span></u></a
              >
              are determined not to apply to a dispute between the parties, (i)
              this Contract shall be governed by and construed in accordance
              with the laws of the state of Texas, without regard to principles
              of conflict or choice of law; and (ii) any dispute arising out of
              or in connection with this Contract shall be filed and heard in
              the state or federal courts located in Dallas, Texas, and the
              parties consent to the exclusive jurisdiction of such courts.
            </li>
            <li style="margin-left: 36pt; text-align: justify">
              <strong>Relationship of Parties:</strong> The parties to this
              Contract are not joint venturers, partners, agents, or
              representatives of each other, are not authorized to act on each
              other’s behalf, and have no legal relationship other than as
              independent contracting parties to this Contract.
            </li>
            <li style="margin-left: 36pt; text-align: justify">
              <strong>Assignment:</strong> No party may assign this Contract, or
              any rights or obligations hereunder, without the prior written
              consent of the other party. Notwithstanding the foregoing, in the
              event that any license agreement between the Foundation and its
              licensor is terminated, the Foundation may, without Participant’s
              consent, assign its rights and obligations with respect to any
              sublicense granted hereunder to such licensor. Any attempt to
              assign this Contract in contravention of this Section shall be
              void and of no force and effect. This Contract is binding upon and
              will inure to the benefit of the respective parties hereto and
              their successors and permitted assigns.
            </li>
            <li style="margin-left: 36pt; text-align: justify">
              <strong>Limitation of Liability:</strong> EXCEPT WITH RESPECT TO
              INDEMNIFICATION OBLIGATIONS SET FORTH HEREIN, NEITHER PARTY SHALL
              BE LIABLE TO THE OTHER FOR ANY (I) DIRECT DAMAGES, IN THE
              AGGREGATE, IN EXCESS OF $100.00, OR (II) INDIRECT, SPECIAL,
              CONSEQUENTIAL, INCIDENTAL, OR PUNITIVE DAMAGE WITH RESPECT TO ANY
              CLAIM ARISING OUT OF THIS CONTRACT (INCLUDING ITS PERFORMANCE OR
              BREACH OF THESE TERMS AND CONDITIONS) FOR ANY REASON.
            </li>
            <li style="margin-left: 36pt; text-align: justify">
              <strong>Notices:</strong> All notices required or permitted to be
              given hereunder shall be in writing and shall be sent by (i)
              personal or courier delivery, (ii) electronic mail, or (iii) USPS
              certified mail, postage prepaid, return receipt requested. All
              notices to Participant shall be forwarded to Participant and/or
              the Primary Contact designated by Participant at the principal
              mailing address and/or email address provided for Participant when
              completing the Registration Form, or to such other person or
              address as Participant may designate in writing to the Foundation
              for this purpose. All notices to the Foundation shall be forwarded
              to OneSight EssilorLuxottica Foundation, 13515 N. Stemmons Fwy.,
              Dallas, TX 75234, Attn: Partnerships (if notice is sent by mail or
              personal or courier delivery) and/or to
              <a href="mailto:info@onesight.org" style="text-decoration: none"
                ><u
                  ><span style="color: #467886">support@onesight.org</span></u
                ></a
              >
              (if notice is sent by electronic mail), or to such other person or
              address as the Foundation may designate in writing to Participant
              for this purpose. In order for notice to the Foundation to be
              effective, a copy of such notice must be sent to OneSight
              EssilorLuxottica Foundation, Attn: General Counsel, at the
              Foundation address designated above (if notice is sent by mail or
              personal or courier delivery). Notices delivered hereunder shall
              be effective when received or refused. Notwithstanding the
              foregoing, (i) written approvals and authorizations required
              hereunder may be provided facsimile, email, or other written
              means; and (ii) the Foundation may notify Participant, including
              notice of any change to the CLTL Program or the terms of the
              Contract, by posting a notice on the Portal.
            </li>
            <li style="margin-left: 36pt; text-align: justify">
              <strong>Entire Agreement:</strong> Except as expressly and
              specifically provided in this Contract, this Contract supersedes
              any prior understandings or oral agreements between the parties
              regarding the subject matter hereof and constitutes the entire
              understanding and agreement of such parties with respect to the
              subject matter hereof.
            </li>
            <li style="margin-left: 36pt; text-align: justify">
              <strong>Force Majeure:</strong> The obligations of any party under
              this Contract will be suspended for the duration of any force
              majeure applicable to that party. The term "force majeure" means
              any cause not reasonably within the control of the party claiming
              suspension, including an act of God, industrial disturbance,
              supplier disruptions, war, riot, weather-related disaster,
              earthquake and governmental action. The party claiming suspension
              under this Section will take reasonable steps to resume
              performance as soon as possible without incurring unreasonably
              excessive costs.
            </li>
            <li style="margin-left: 36pt; text-align: justify">
              <strong>Miscellaneous:</strong> The failure of a party at any time
              to require performance of any provision of or resort to any remedy
              provided under this Contract shall in no way affect the right of
              that party to require performance or resort to a remedy at any
              time thereafter, nor shall the waiver by a party of a breach be
              deemed to be a waiver of any subsequent breach. A waiver shall not
              be effective unless it is in writing and signed by the party
              against whom the waiver is being enforced. If any term or
              provision of this Contract is determined to be invalid, illegal,
              or incapable of being enforced by any law, regulation, or public
              policy,<span
                style="line-height: 115%; font-family: Aptos; font-size: 10pt"
              >
              </span
              >then such provision will be interpreted, construed, or reformed
              to the extent reasonably required to render the same valid,
              enforceable and consistent with the original intent underlying
              such provision, and all other terms and provisions of this
              Contract shall nevertheless remain in full force and effect.
              Notwithstanding the foregoing, if any such modification causes a
              material change in the obligations or rights of any party, upon
              written notice from one party to the other of the adverse effect
              thereof upon such notifying party, and then if the parties are not
              able to mutually agree as to an amendment hereto, any party may
              terminate this Contract upon thirty (30) days written notice to
              the other parties.This Contract shall not be altered, amended, or
              modified in any way except by (i) a written instrument dated
              subsequent to the date of this Contract and signed on behalf of
              the parties by their respective duly authorized representatives;
              or (ii) a subsequent “clickwrap” agreement made available by the
              Foundation on the Portal to which Participant has indicated
              Participant’s assent by clicking an “I Agree” or “Submit” or
              similar button. Section captions and headings are for are for
              reference purposes only and shall not control or affect the
              construction or interpretation of this Contract in any
              respect.&#xa0; In all cases, the use of "includes/ing" shall mean
              "includes/ing without limitation".
            </li>
          </ol>
          <p style="margin-top: 0pt; margin-bottom: 0pt; text-align: justify">
            &#xa0;
          </p>
          <div class="terms-section mt-4">Business Associate Agreement</div>

          <p
            style="
              margin-top: 12pt;
              margin-bottom: 0pt;
              text-align: justify;
              line-height: normal;
              background-color: #ffffff;
            "
          >
            <span style="letter-spacing: 0.1pt; color: #444444"
              >This HIPAA Business Associate Agreement ("Agreement") supplements
              and is made a part of the Changing Life through Lenses® Agreement
              ("CLTL Contract") by and between the legal entity or individual
              identified as the participant on the Champions for Sight®
              registration form (referred to herein as “Covered Entity") and
              OneSight d/b/a OneSight EssilorLuxottica Foundation (referred to
              herein as "Business Associate"), and is effective as of the
              Effective Date of the CLTL Contract between the parties, as
              defined in the Changing Life through Lenses® Terms and
              Conditions.</span
            >
          </p>
          <p
            style="
              margin-top: 14pt;
              margin-bottom: 14pt;
              line-height: normal;
              background-color: #ffffff;
            "
          >
            <strong
              ><span style="letter-spacing: 0.1pt; color: #444444"
                >RECITALS</span
              ></strong
            >
          </p>
          <ul type="disc" style="margin: 0pt; padding-left: 0pt">
            <li
              style="
                margin-left: 9.6pt;
                text-align: justify;
                line-height: normal;
                padding-left: 8.4pt;
                font-family: serif;
                font-size: 10pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong
                ><span style="font-family: Arial; font-size: 11pt"
                  >WHEREAS</span
                ></strong
              ><span style="font-family: Arial; font-size: 11pt"
                >, Business Associate provides certain services to health care
                providers; and</span
              >
            </li>
            <li
              style="
                margin-left: 9.6pt;
                text-align: justify;
                line-height: normal;
                padding-left: 8.4pt;
                font-family: serif;
                font-size: 10pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong
                ><span style="font-family: Arial; font-size: 11pt"
                  >WHEREAS</span
                ></strong
              ><span style="font-family: Arial; font-size: 11pt"
                >, Business Associate has been retained by Covered Entity to
                perform functions or activities that will require the Business
                Associate to have access to or create, receive, maintain or
                transmit Protected Health Information in relation to the Covered
                Entity; and</span
              >
            </li>
            <li
              style="
                margin-left: 9.6pt;
                text-align: justify;
                line-height: normal;
                padding-left: 8.4pt;
                font-family: serif;
                font-size: 10pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong
                ><span style="font-family: Arial; font-size: 11pt"
                  >WHEREAS</span
                ></strong
              ><span style="font-family: Arial; font-size: 11pt"
                >, Pursuant to the Health Insurance Portability and
                Accountability Act of 1996 ("HIPAA"), Covered Entity and
                Business Associate desire to execute this Agreement to comply
                with the terms of the Privacy Rule, the Security Rule and the
                HITECH Act under the American Recovery and Reinvestment Act of
                2009 (as defined below); and</span
              >
            </li>
            <li
              style="
                margin-left: 9.6pt;
                text-align: justify;
                line-height: normal;
                padding-left: 8.4pt;
                font-family: serif;
                font-size: 10pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong
                ><span style="font-family: Arial; font-size: 11pt"
                  >WHEREAS</span
                ></strong
              ><span style="font-family: Arial; font-size: 11pt"
                >, this Agreement has been drafted to incorporate the provisions
                required by the final regulations issued by the Department of
                Health and Human Services on January 25, 2013 implementing the
                HITECH Act; and</span
              >
            </li>
            <li
              style="
                margin-left: 9.6pt;
                text-align: justify;
                line-height: normal;
                padding-left: 8.4pt;
                font-family: serif;
                font-size: 10pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong
                ><span style="font-family: Arial; font-size: 11pt"
                  >WHEREAS,</span
                ></strong
              ><span style="font-family: Arial; font-size: 11pt">
                Business Associate acts in the capacity of an independent
                contractor in relation to the services provided to Covered
                Entity under the CLTL Contract.</span
              >
            </li>
            <li
              style="
                margin-left: 9.6pt;
                text-align: justify;
                line-height: normal;
                padding-left: 8.4pt;
                font-family: serif;
                font-size: 10pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong
                ><span style="font-family: Arial; font-size: 11pt"
                  >NOW, THEREFORE</span
                ></strong
              ><span style="font-family: Arial; font-size: 11pt"
                >, in consideration of the mutual covenants, terms and
                conditions herein contained, the parties hereto agree as
                follows:</span
              >
            </li>
          </ul>
          <p
            style="
              margin-top: 14pt;
              margin-bottom: 14pt;
              text-align: justify;
              line-height: normal;
              background-color: #ffffff;
            "
          >
            <strong
              ><span style="letter-spacing: 0.1pt; color: #444444"
                >1) DEFINITIONS</span
              ></strong
            >
          </p>
          <p
            style="
              margin-top: 14pt;
              margin-bottom: 14pt;
              text-align: justify;
              line-height: normal;
              background-color: #ffffff;
            "
          >
            <span style="letter-spacing: 0.1pt; color: #444444"
              >Terms used but not otherwise defined in the Agreement shall have
              the same meaning as those terms in the Privacy Rule and Security
              Rule.</span
            >
          </p>
          <ol type="1" style="margin: 0pt; padding-left: 0pt">
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>"Breach"</strong>&#xa0;shall have the meaning given to it
              by 45 CFR Section 164.402.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>"Breach Notification Rule"</strong
              ><strong>&#xa0;</strong>shall mean the Standards for Breach
              Notification for Unsecured Protected Health Information under
              HIPAA that is codified at 45&#xa0;CFR Parts&#xa0;160 and 164,
              subparts&#xa0;A and D.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>"Deidentified Data"</strong>&#xa0;shall have the same
              meaning as the term "deidentified data" in 45&#xa0;CFR
              Section&#xa0;164.514.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>"Designated Record Set"</strong>&#xa0;shall mean a group
              of records maintained by or for a Covered Entity that is:
              (i)&#xa0;the medical records and billing records about Individuals
              maintained by or for a covered health care provider; (ii)&#xa0;the
              enrollment, payment, claims adjudication, and case or medical
              management record systems maintained by or for a health plan; or
              (iii)&#xa0;used, in whole or in part, by or for the Covered Entity
              to make decisions about Individuals. For purposes of this
              definition, the term "record" means any item, collection, or
              grouping of information that includes Protected Health Information
              and is maintained, collected, used, or disseminated by or for a
              Covered Entity.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>"Health Care Operations"</strong>&#xa0;shall have the same
              meaning as the term "Health Care Operations" in 45&#xa0;CFR
              Section&#xa0;164.501.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>"HITECH Act"</strong>&#xa0;shall mean the provisions of
              Title&#xa0;XIII, Subtitle&#xa0;D of the American Recovery and
              Reinvestment Act of 2009. Any reference to a section of the HITECH
              Act shall also include any HITECH Regulations related thereto.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>"HITECH Regulations"</strong>&#xa0;shall mean any guidance
              issued relating to the HITECH Act by the Department of Health and
              Human Services, including the Breach Notification Rule.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>"Individual"</strong>&#xa0;shall have the same meaning as
              the term "individual" in 45&#xa0;CFR Section&#xa0;160.103 and
              shall include a person who qualifies as a personal representative
              in accordance with&#xa0;45 CFR Section&#xa0;164.502(g).
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>"Privacy Rule"</strong>&#xa0;shall mean the Standards for
              Privacy of Individually Identifiable Health Information that is
              codified at 45&#xa0;CFR Parts&#xa0;160 and 164, subparts&#xa0;A
              and E.
            </li>
            <li
              style="
                margin-left: 36pt;
                text-align: justify;
                line-height: normal;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>"Protected Health Information"</strong
              >&#xa0;or&#xa0;<strong>"PHI"</strong>&#xa0;shall mean any
              information, whether oral or recorded in any form or medium:
              (i)&#xa0;that relates to the past, present or future physical or
              mental condition of an individual; the provision of health care to
              an individual; or the past, present or future payment for the
              provision of health care to an individual; and (ii)&#xa0;that
              identifies the individual or with respect to which there is a
              reasonable basis to believe the information can be used to
              identify the individual, and shall have the meaning given to such
              term under 45&#xa0;CFR Section&#xa0;160.103. Protected Health
              Information shall be limited to the information created or
              received by Business Associate from or on behalf of Covered
              Entity.
            </li>
            <li
              style="
                margin-left: 36pt;
                text-align: justify;
                line-height: normal;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>"Required By Law"</strong>&#xa0;shall have the same
              meaning as the term "required by law" in 45&#xa0;CFR
              Section&#xa0;164.103.
            </li>
            <li
              style="
                margin-left: 36pt;
                text-align: justify;
                line-height: normal;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>"Secretary"</strong>&#xa0;shall mean the Secretary of the
              Department of Health and Human Services or his or her designee.
            </li>
            <li
              style="
                margin-left: 36pt;
                text-align: justify;
                line-height: normal;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>"Security Rule"</strong>&#xa0;shall mean the Security
              Standards for the Protection of Electronic Protected Health
              Information under HIPAA that is codified at 45&#xa0;CFR
              Parts&#xa0;160 and 164, subparts&#xa0;A and C.
            </li>
            <li
              style="
                margin-left: 36pt;
                text-align: justify;
                line-height: normal;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>"Unsecured PHI"</strong>&#xa0;shall mean Protected Health
              Information that is not secured through the use of a technology or
              methodology that renders such Protected Health Information
              unusable, unreadable or indecipherable to unauthorized
              individuals, as specified in guidance issued pursuant to
              Section&#xa0;13402(h) of the HITECH Act, including the Breach
              Notification Rule.
            </li>
          </ol>
          <p
            style="
              margin-top: 14pt;
              margin-bottom: 14pt;
              text-align: justify;
              line-height: normal;
              background-color: #ffffff;
            "
          >
            <strong
              ><span style="letter-spacing: 0.1pt; color: #444444"
                >2) OBLIGATIONS AND ACTIVITIES OF BUSINESS ASSOCIATE</span
              ></strong
            >
          </p>
          <ol type="1" style="margin: 0pt; padding-left: 0pt">
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>Permitted Uses and Disclosures</strong>. Business
              Associate agrees to not use or disclose Protected Health
              Information other than as permitted or required by this Agreement
              or as Required By Law. Business Associate shall not use or
              disclose Protected Health Information in any manner that violates
              the Privacy Rule or the HITECH Act. To the extent required by the
              Privacy Rule, Business Associate shall only request, use and/or
              disclose the minimum amount of Protected Health Information
              necessary to accomplish the purpose of the request, use and/or
              disclosure. The determination of what constitutes the minimum
              necessary amount of Protected Health Information shall be
              determined in accordance with the provisions of the Privacy Rule.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>Safeguards</strong>. Business Associate agrees to use
              administrative, physical and technical safeguards applicable to
              the services provided under the CLTL Contract that reasonably and
              appropriately protect the confidentiality, integrity and
              availability of Protected Health Information, in electronic or any
              other form, that it creates, receives, maintains or transmits
              under this Agreement, in accordance with the Privacy Rule and the
              Security Rule to prevent the use or disclosure of Protected Health
              Information other than as provided for by this Agreement. Business
              Associate shall fully comply with the Security Rule with regard to
              electronic Protected Health Information.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>Reporting of Improper Use or Disclosure</strong>. Business
              Associate agrees to report to the Covered Entity any use or
              disclosure of the Protected Health Information not provided for by
              this Agreement of which it becomes aware. Business Associate shall
              also report any security incident of which it becomes aware to
              Covered Entity.&#xa0;
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>Mitigation.</strong>&#xa0;Business Associate agrees to
              mitigate, to the extent practicable, any harmful effect that is
              known to Business Associate of a use or disclosure of Protected
              Health Information by Business Associate in violation of the
              requirements of this Agreement.&#xa0;
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>Agents and Subcontractors.</strong>&#xa0;Business
              Associate agrees to require that any agents or subcontractors that
              create, receive, maintain or transmit Protected Health Information
              on behalf of Business Associate in relation to Covered Entity
              agree in writing (in the form of a business associate contract) to
              substantially similar restrictions, conditions and requirements
              that apply through this Agreement to Business Associate with
              respect to such information, including the implementation of
              reasonable and appropriate measures for safeguarding Protected
              Health Information.&#xa0;
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>Access to Individuals.</strong>&#xa0;To the extent
              applicable, Business Associate agrees to provide access to
              Protected Health Information in a Designated Record Set, to
              Covered Entity or, as directed by Covered Entity, to an Individual
              in order to meet the requirements under 45 CFR
              Section&#xa0;164.524. Further, if an Individual requests a copy of
              Protected Health Information in a specific electronic format,
              Business Associate shall comply with such request, if readily
              producible, in accordance with the requirements of 45 CFR Section
              164.524.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>Amendments to Protected Health Information.</strong
              >&#xa0;To the extent applicable, Business Associate agrees to make
              any reasonable amendment(s) to Protected Health Information in a
              Designated Record Set that the Covered Entity directs or agrees to
              pursuant to 45 CFR Section&#xa0;164.526 at the request of Covered
              Entity or an Individual.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>Access to Internal Practices, Books and Records.</strong
              >&#xa0;Business Associate agrees to make internal practices, books
              and records including policies and procedures and Protected Health
              Information, relating to the use and disclosure of Protected
              Health Information received from, or created or received by
              Business Associate on behalf of, Covered Entity available to the
              Secretary for purposes of the Secretary determining Covered
              Entity's compliance with HIPAA.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>Disclosure Documentation.</strong>&#xa0;Business Associate
              agrees to document such disclosures of Protected Health
              Information and information related to such disclosures as would
              be required for Covered Entity to respond to a request by an
              Individual for an accounting of disclosures of Protected Health
              Information in accordance with 45 CFR Section&#xa0;164.528.
              Business Associate agrees to provide to Covered Entity or an
              Individual information collected in accordance with this
              subsection to permit Covered Entity to respond to a request by an
              Individual for an accounting of disclosures of Protected Health
              Information in accordance with 45 CFR Section&#xa0;164.528.
            </li>
            <li
              style="
                margin-left: 36pt;
                text-align: justify;
                line-height: normal;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>Obligation Upon Breach of Unsecured PHI.</strong
              ><strong>&#xa0;</strong>Upon Business Associate's discovery of a
              Breach of Unsecured PHI, Business Associate shall provide notice
              of the Breach to Covered Entity in accordance with the
              requirements of 45 CFR 164.410. The content of such written notice
              of the Breach shall comply with the requirements of 45&#xa0;CFR
              Section&#xa0;164.410(c). Business Associate shall cooperate with
              and coordinate an appropriate course of action with Covered
              Entity.
            </li>
            <li
              style="
                margin-left: 36pt;
                text-align: justify;
                line-height: normal;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>Delegated Obligations</strong>. To the extent Business
              Associate is to carry out one or more of Covered Entity’s
              obligations under Subpart E of 45 CFR Part 164, Business Associate
              agrees to comply with the requirements of Subpart E that apply to
              Covered Entity in the performance of such obligations.
            </li>
          </ol>
          <p
            style="
              margin-top: 14pt;
              margin-bottom: 14pt;
              text-align: justify;
              line-height: normal;
              background-color: #ffffff;
            "
          >
            <strong
              ><span style="letter-spacing: 0.1pt; color: #444444"
                >&#xa0;</span
              ></strong
            >
          </p>
          <p
            style="
              margin-top: 14pt;
              margin-bottom: 14pt;
              text-align: justify;
              line-height: normal;
              background-color: #ffffff;
            "
          >
            <strong
              ><span style="letter-spacing: 0.1pt; color: #444444"
                >&#xa0;</span
              ></strong
            >
          </p>
          <p
            style="
              margin-top: 14pt;
              margin-bottom: 14pt;
              text-align: justify;
              line-height: normal;
              background-color: #ffffff;
            "
          >
            <strong
              ><span style="letter-spacing: 0.1pt; color: #444444"
                >3) PERMITTED USES BY BUSINESS ASSOCIATE</span
              ></strong
            >
          </p>
          <ol type="1" style="margin: 0pt; padding-left: 0pt">
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>Service Agreement.</strong>&#xa0;Except as otherwise
              limited in this Agreement, Business Associate may use or disclose
              Protected Health Information to perform functions, activities, or
              services for, or on behalf of, Covered Entity as specified in the
              CLTL Contract, provided that such use or disclosure would not
              violate the Privacy Rule if done by Covered Entity.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                margin-bottom: 12pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>Other Permitted Usage.</strong>&#xa0;Except as otherwise
              limited in this Agreement, Business Associate may use Protected
              Health Information for the proper management and administration of
              the Business Associate or to carry out the legal responsibilities
              of the Business Associate. Business Associate may disclose
              Protected Health Information for the proper management and
              administration of the Business Associate if the disclosure is
              Required by Law or Business Associate obtains reasonable
              assurances from the person to whom the information is disclosed
              that it will be held confidentially and used or further disclosed
              only as Required by Law or for the purposes for which it was
              disclosed to the person and the person notifies Business Associate
              of any instances of which it is aware in which the confidentiality
              of the information has been breached.&#xa0; In addition, Business
              Associate may use Protected Health Information to provide Data
              Aggregation services as permitted by 45&#xa0;CFR
              Section&#xa0;164.504(e)(2)(i)(B) and/or to create Limited Data
              Sets as permitted by 45 CFR 164.514(e).
            </li>
          </ol>
          <p
            style="
              margin-top: 14pt;
              margin-left: 36pt;
              margin-bottom: 14pt;
              text-align: justify;
              line-height: normal;
            "
          >
            <span style="letter-spacing: 0.1pt; color: #444444"
              >The Business Associate’s activities will require access to
              Protected Health Information to process prescriptions placed by
              the Covered Entity pursuant to the CLTL Contract. Also, Business
              Associate may also facilitate certain treatment activities (as
              defined at 45 CFR 164.501) and perform certain health care
              operation functions (as defined at 45 CFR 164.501), including
              conducting certain audit functions, on behalf of the Covered
              Entity.</span
            ><br /><br /><span style="letter-spacing: 0.1pt; color: #444444"
              >Further, Covered Entity expressly agrees to provide Business
              Associate with Protected Health Information, as requested by
              Business Associate from time to time, so that Business Associate
              may create a limited data set with such information that complies
              with the requirements of 45 CFR 164.514(e). After creating the
              limited data set, Business Associate will conduct research on the
              limited data set, as allowed under 45 CFR 164.514(e)(3). The
              Business Associate will not use or further disclose the limited
              data set information in a manner that would violate the
              requirements of the Privacy Rule. In relation to the limited data
              set information maintained by Business Associate, Business
              Associate will use appropriate safeguards to prevent use or
              disclosure of the information other than as provided for by this
              Agreement; report to the Covered Entity any use or disclosure of
              the information not provided for by this Agreement of which it
              becomes aware; ensure that any agents to whom it provides the
              limited data set agree to the same restrictions and conditions
              that apply to the limited data set recipient with respect to such
              information; and not identify the information or contact the
              individuals, in accordance with the requirements of 45 CFR
              164.514(e)(4)(ii)(C).</span
            >
          </p>
          <p
            style="
              margin-top: 14pt;
              margin-bottom: 14pt;
              text-align: justify;
              line-height: normal;
              background-color: #ffffff;
            "
          >
            <strong
              ><span style="letter-spacing: 0.1pt; color: #444444"
                >4) OBLIGATIONS OF COVERED ENTITY</span
              ></strong
            >
          </p>
          <ol type="1" style="margin: 0pt; padding-left: 0pt">
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>Change in Privacy Practices.</strong>&#xa0;Covered Entity
              shall notify Business Associate of any limitation(s) in its notice
              of privacy practices of Covered Entity in accordance with 45 CFR
              Section 164.520, to the extent that such limitation may affect
              Business Associate's use or disclosure of Protected Health
              Information. Additionally, Covered Entity shall notify Business
              Associate of any limitation(s) or restriction(s) in its security
              practices to the extent that such limitation may affect Business
              Associate's use or disclosure of Protected Health Information.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong
                >No Restrictions on the Use or Disclosure of Protected Health
                Information.</strong
              >&#xa0;Covered Entity shall not agree to an Individual’s request
              to restrict uses or discloses of Protected Health Information, to
              the extent that such changes may affect Business Associate's
              ability to perform the functions described in the CLTL Contract,
              including this Agreement. Because of the charitable nature of the
              services performed in relation to the Covered Entity’s patients
              whose PHI is subject to this Agreement, 45 CFR 164.522(a)(1)(vi)
              will not apply to the PHI of such patients since such patients are
              not paying in full for services performed. Therefore, the Covered
              Entity is allowed under 45 CFR 164.522(a)(1)(ii) to not agree, and
              shall not agree, to any restriction requested by an Individual
              whose PHI will be shared with Business Associate as part of the
              services provided under the CLTL Contract.&#xa0;
            </li>
          </ol>
          <p
            style="
              margin-top: 14pt;
              margin-bottom: 14pt;
              text-align: justify;
              line-height: normal;
              background-color: #ffffff;
            "
          >
            <strong
              ><span style="letter-spacing: 0.1pt; color: #444444"
                >5) PERMISSIBLE REQUESTS BY COVERED ENTITY</span
              ></strong
            >
          </p>
          <ol type="1" style="margin: 0pt; padding-left: 0pt">
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              Covered Entity shall not request Business Associate to use or
              disclose Protected Health Information in any manner that would not
              be permissible under the Privacy Rule if done by Covered Entity.
            </li>
          </ol>
          <p
            style="
              margin-top: 14pt;
              margin-bottom: 14pt;
              text-align: justify;
              line-height: normal;
              background-color: #ffffff;
            "
          >
            <strong
              ><span style="letter-spacing: 0.1pt; color: #444444"
                >6) TERM AND TERMINATION</span
              ></strong
            >
          </p>
          <ol type="1" style="margin: 0pt; padding-left: 0pt">
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>Term.</strong>&#xa0;This Agreement will begin on the
              Effective Date and will continue until terminated in accordance
              herein.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>Termination. </strong>In addition to the termination
              rights set forth in the Terms and Conditions, a party may
              terminate the Agreement as follows:&#xa0;
              <ol
                type="1"
                style="margin-right: 0pt; margin-left: 0pt; padding-left: 0pt"
              >
                <li style="margin-left: 32.17pt; padding-left: 3.83pt">
                  <strong>Termination for Cause.</strong>&#xa0;Upon Covered
                  Entity's knowledge of a material breach of this Agreement by
                  Business Associate, Covered Entity shall provide not less than
                  20 days written notice of its intent to terminate the
                  Agreement if Business Associate does not cure such material
                  breach no later than the end of the written notice period. If
                  Business Associate does not cure the breach within such time,
                  then Covered Entity may, in its sole discretion, immediately
                  terminate this Agreement.
                </li>
                <li style="margin-left: 32.17pt; padding-left: 3.83pt">
                  <strong
                    >Termination without Cause and Termination of the CLTL
                    Contract. </strong
                  >Either party may terminate this Agreement effective upon 15
                  days advance written notice to the other party given with or
                  without any reason if Business Associate no longer performs
                  services for Covered Entity requiring the use or disclosure of
                  Protected Health Information. This Agreement will immediately
                  terminate if the CLTL Contract terminates. The effective date
                  of such termination will be the same as the effective date
                  that the CLTL Contract terminates.
                </li>
                <li style="margin-left: 32.17pt; padding-left: 3.83pt">
                  <strong>Effect of Termination.</strong>&#xa0;Unless otherwise
                  mutually agreed by the parties, the termination of this
                  Agreement for any reason shall automatically terminate the
                  CLTL Contract. The parties mutually agree in advance that
                  returning or destroying Protected Health Information upon
                  termination of this Agreement is infeasible. Therefore,
                  Business Associate shall extend the protections of this
                  Agreement to such Protected Health Information and limit
                  further uses and disclosures of such Protected Health
                  Information to those purposes that make the return or
                  destruction infeasible, for so long as Business Associate
                  maintains such Protected Health Information.
                </li>
              </ol>
            </li>
          </ol>
          <p
            style="
              margin-top: 14pt;
              margin-bottom: 14pt;
              text-align: justify;
              line-height: normal;
              background-color: #ffffff;
            "
          >
            <strong
              ><span style="letter-spacing: 0.1pt; color: #444444"
                >7) MISCELLANEOUS</span
              ></strong
            >
          </p>
          <ol type="1" style="margin: 0pt; padding-left: 0pt">
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>Regulatory References.</strong>&#xa0;Any reference in this
              Agreement to a section in the Privacy Rule, Security Rule, Breach
              Notification Rule or HITECH Act means the section as in effect or
              as amended.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>Amendment.</strong>&#xa0;The Parties agree to take such
              action as is necessary to amend this Agreement from time to time
              as is necessary for Covered Entity to comply with the requirements
              of the Privacy Rule, Security Rule, the Breach Notification Rule
              or any other requirements of the HITECH Act.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>Survival.</strong>&#xa0;The respective rights and
              obligations of Business Associate under Section&#xa0;6.2.3 shall
              survive the termination of this Agreement.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>Interpretation; Conflict.</strong>&#xa0;Any ambiguity in
              this Agreement shall be resolved to permit both parties to comply
              with the Privacy Rule, Security Rule, the Breach Notification Rule
              or any other requirements of the HITECH Act.&#xa0;
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>No Third-Party Beneficiaries.</strong>&#xa0;Except as set
              forth in this Agreement or as expressly provided for under HIPAA,
              this Agreement is entered into by and among the parties hereto
              solely for their benefit. The parties have not created or
              established any third-party beneficiary status or rights in any
              person or entity not a party hereto including any individual,
              provider, subcontractor, or other third-party, and no such
              third-party will have any right to enforce any right or enjoy any
              benefit created or established under this Agreement.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>Force Majeure.</strong>&#xa0;The obligations of any party
              under this Agreement will be suspended for the duration of any
              force majeure applicable to that party. The term "force majeure"
              means any cause not reasonably within the control of the party
              claiming suspension, including an act of God, industrial
              disturbance, supplier disruptions, war, riot, weather-related
              disaster, earthquake and governmental action. The party claiming
              suspension under this Section will take reasonable steps to resume
              performance as soon as possible without incurring unreasonably
              excessive costs.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>Entire Agreement.</strong>&#xa0;This Agreement including
              any riders, attachments or amendments hereto, constitutes the
              entire agreement among the parties with respect to the Privacy
              Rule, the Security Rule, the Breach Notification Rule and any
              other requirements of the HITECH Act. This Agreement supersedes
              any prior agreement or understandings pertaining to HIPAA
              obligations between the parties, whether oral or written.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>Disputes; Choice of Law.</strong>&#xa0;<strong
                ><u
                  >Any disputes between the parties related to this Agreement
                  shall be governed by the “Disputes with OneSight
                  EssilorLuxottica Foundation” section of the
                </u></strong
              ><a
                href="https://www.evfusa.org/terms-and-conditions/"
                target="_blank"
                style="text-decoration: none"
                ><strong
                  ><u
                    ><span style="color: #467886">Terms of Use</span></u
                  ></strong
                ></a
              ><strong
                ><u
                  >, including, to the extent applicable, the Agreement to
                  Arbitrate set forth in the “Disputes with OneSight
                  EssilorLuxottica Foundation” section of the
                </u></strong
              ><a
                href="https://www.evfusa.org/terms-and-conditions/"
                target="_blank"
                style="text-decoration: none"
                ><strong
                  ><u
                    ><span style="color: #467886">Terms of Use</span></u
                  ></strong
                ></a
              ><u>.</u> If and to the extent the
              <a
                href="https://www.evfusa.org/terms-and-conditions/"
                target="_blank"
                style="text-decoration: none"
                ><strong
                  ><u
                    ><span style="color: #467886">Terms of Use</span></u
                  ></strong
                ></a
              >
              are determined not to apply to a dispute between the parties, (i)
              this Agreement shall be governed by and construed in accordance
              with the laws of the state of Texas, without regard to principles
              of conflict or choice of law; and (ii) any dispute arising out of
              or in connection with this Agreement shall be filed and heard in
              the state or federal courts located in Dallas, Texas, and the
              parties consent to the exclusive jurisdiction of such courts.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>Assignment and Delegation.</strong>&#xa0;No party may
              assign this Agreement, or any rights or obligations hereunder,
              without the prior written consent of the other party. Any attempt
              to assign this Agreement in contravention of this Section shall be
              void and of no force and effect. This Agreement is binding upon
              and will inure to the benefit of the respective parties hereto and
              their successors and permitted assigns.
            </li>
            <li
              style="
                margin-left: 36pt;
                text-align: justify;
                line-height: normal;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>Notices.</strong>&#xa0;Any notice required pursuant to
              this Agreement shall comply with the requirements for notices as
              set forth in the OneSight EssilorLuxottica Foundation Changing
              Life through Lenses® Terms and Conditions that form part of the
              CLTL Contract.
            </li>
            <li
              style="
                margin-left: 36pt;
                text-align: justify;
                line-height: normal;
                letter-spacing: 0.1pt;
                color: #444444;
              "
            >
              <strong>Miscellaneous.</strong> The failure of a party at any time
              to require performance of any provision of or resort to any remedy
              provided under this Agreement shall in no way affect the right of
              that party to require performance or resort to a remedy at any
              time thereafter, nor shall the waiver by a party of a breach be
              deemed to be a waiver of any subsequent breach. A waiver shall not
              be effective unless it is in writing and signed by the party
              against whom the waiver is being enforced. If any term or
              provision of this Agreement is determined to be invalid, illegal,
              or incapable of being enforced by any law, regulation, or public
              policy, then such provision will be interpreted, construed or
              reformed to the extent reasonably required to render the same
              valid, enforceable and consistent with the original intent
              underlying such provision, and all other terms and provisions of
              this Agreement shall nevertheless remain in full force and effect.
              Notwithstanding the foregoing, if any such modification causes a
              material change in the obligations or rights of any party, upon
              written notice from one party to the other of the adverse effect
              thereof upon such notifying party, and then if the parties are not
              able to mutually agree as to an amendment hereto, any party may
              terminate this Agreement upon thirty (30) days written notice to
              the other parties. This Agreement shall not be altered, amended or
              modified in any way except by (i) a written instrument dated
              subsequent to the date of this Agreement and signed on behalf of
              the parties by their respective duly authorized representatives;
              or (ii) a subsequent “clickwrap” agreement made available by the
              Foundation on the OneSight EssilorLuxottica Foundation Changing
              Life through Lenses® online platform to which Covered Entity has
              indicated Covered Entity’s assent by clicking an “I Agree” or
              “Submit” or similar button. Section captions and headings are for
              are for reference purposes only and shall not control or affect
              the construction or interpretation of this Agreement in any
              respect. In all cases, the use of "includes/ing" shall mean
              "includes/ing without limitation".
            </li>
          </ol>

          <div class="terms-section mt-5">Grateful Patient™ Agreement</div>

          <p style="margin-top: 12pt; margin-bottom: 4pt; line-height: normal">
            <strong
              >Grateful Patient™ Point of Sale Giving Campaign Terms and
              Conditions</strong
            >
          </p>
          <ol type="1" style="margin: 0pt; padding-left: 0pt">
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
              "
            >
              <strong>Definitions; Effective Date. </strong>These Grateful
              Patient™ Point of Sale Giving Terms and Conditions (“<strong
                >Grateful Patient™ Terms and Conditions</strong
              >”) supplement and are made part of the Grateful Patient™ ™ Point
              of Sale Agreement (“<strong>Grateful Patient™ Contract</strong>”)
              by and between the legal entity or individual identified as the
              participant (“<strong>Participant</strong>”) on the Champions for
              Sight registration form (“<strong>Registration Form</strong>”) and
              these Terms and Conditions, and OneSight d/b/a OneSight
              EssilorLuxottica Foundation (“<strong>Foundation</strong>”).
              Capitalized terms used but not defined in these Grateful Patient™
              Terms and Conditions shall have the meaning ascribed to them in
              the Registration Form. If you accept this Grateful Patient™
              Contract, the date on which you click the “Agree &amp; Submit” or
              similar button shall be the effective date of the Grateful
              Patient™ Contract (“<strong>Effective Date</strong>”).
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
              "
            >
              <strong>Program Information.</strong><strong>&#xa0;</strong> The
              Foundation has created the Grateful Patient™ Program, a charitable
              point of sale (“<strong>POS</strong>”) fundraising program (the
              “<strong>Grateful Patient™</strong> <strong>Program</strong>”) for
              independent eyecare professionals and businesses. The purpose of
              the Grateful Patient™ Program is to raise funds for the benefit of
              The Foundation, whose mission is to eliminate poor vision in a
              generation. Participant can elect to participate in the Grateful
              Patient™ by making available to Participant’s customers at
              Participant’s locations in the United States information enabling
              customers to make a direct donation to the Foundation and/or the
              option to make a donation to The Foundation during the POS
              checkout process (“<strong>POS Donations</strong>”), as more fully
              described in these Terms and Conditions. Except as otherwise
              expressly provided herein, Participant shall be solely responsible
              for all costs of operating the Grateful Patient™ Program,
              including the costs of acquiring and maintaining any POS hardware
              and software. Participant shall direct customer inquiries or
              concerns regarding The Foundation or the Grateful Patient™ Program
              to The Foundation at 1-866-385-0447.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
              "
            >
              <strong>Program Materials.</strong><strong>&#xa0;</strong>
              <strong
                >Participant agrees to print out and prominently display to its
                customers a copy of The Foundation’s then-current disclosures
                related to the solicitation of donations, which can be found at: </strong
              ><a
                href="http://www.championsforsight.org/disclosures"
                style="text-decoration: none"
                ><strong
                  ><u
                    ><span style="color: #467886"
                      >www.championsforsight.org/disclosures</span
                    ></u
                  ></strong
                ></a
              ><strong>.</strong> In addition, upon Participant’s request, The
              Foundation will provide Participant with a digital template of
              promotional materials for purposes of publicizing the Grateful
              Patient™ Program ("<strong
                >Grateful Patient™ Program Materials</strong
              >”). Participant shall be responsible for all costs of printing
              Grateful Patient™ Program Materials supplied in digital formats.
              From time to time, The Foundation may offer printed Grateful
              Patient™ Program Materials. The Foundation may impose a fee for
              printed Grateful Patient™ Program Materials and will inform
              Participant of the amount of such fee prior to fulfilling
              Participant’s request for Grateful Patient™ Program Materials.
              Participant shall use Grateful Patient™ Program Materials solely
              in connection with the Grateful Patient™ Program. Participant
              shall not transfer the Grateful Patient™ Program Materials or its
              right to use the Grateful Patient™ Program Materials to any third
              party. Participant shall use Grateful Patient™ Program Materials
              as is and shall not modify Grateful Patient™ Program Materials in
              any way without the express written approval of The Foundation;
              provided, however, that where Grateful Patient™ Program Materials
              provide a space expressly for co-branding by Grateful Patient™
              Program participants, Participant may add Participant’s business
              logo to such space. Participant shall not delete, obscure, or
              alter any disclosures or any copyright notice, trademarks, or
              other proprietary rights notices affixed to or contained in the
              Grateful Patient™ Program Materials. Upon termination of the
              Grateful Patient™ Contract, Participant shall immediately cease
              use of the Grateful Patient™ Program Materials and destroy all
              Grateful Patient™ Program Materials in Participant’s possession.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
              "
            >
              <strong>OneSight EssilorLuxottica Foundation Marks. </strong
              >Participant acknowledges The Foundation’s right, title and
              interest in its trade names, trademark, trade dress, logos, and
              other indicia of origin owned or licensed by The Foundation (the
              “<strong>Foundation Marks</strong>”). Participant is authorized to
              use non-exclusively the Foundation Marks solely as the Foundation
              Marks are incorporated into the Grateful Patient™ Program
              Materials and shall not use the Foundation Marks for any other
              purpose.
              <a name="_Hlk173319593"
                >Participant shall not transfer, sublicense, or assign its
                rights to use the Grateful Patient™ Program Marks</a
              >. Participant acknowledges and agrees that The Foundation or its
              licensor, as applicable, retains all ownership rights in and to
              the Foundation Marks and that the benefit of use of the Foundation
              Marks hereunder, as well as all trademark and other intellectual
              property rights stemming therefrom, shall inure and belong solely
              to The Foundation or its licensor, as applicable. Participant
              agrees to cease use of the Foundation Marks immediately upon
              termination of this Grateful Patient™ Contract or sooner upon The
              Foundation’s request.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                margin-bottom: 8pt;
                text-align: justify;
                line-height: 108%;
                padding-left: 3.83pt;
              "
            >
              <strong>POS Donations.</strong> In order to support participation
              in the Grateful Patient™ Program, The Foundation has identified a
              number of merchant providers/donation tactics to enable
              Participant to accept POS Donations in the manner best suited to
              Participant’s practice.&#xa0; Depending on Participant’s chosen
              merchant provider/donation tactic, Participant may incur fees,
              charges and/or costs (collectively, “<strong>POS Fees</strong>”)
              of participating in the Grateful Patient™ Program, including POS
              Fees associated with credit card transactions processed in
              connection with the Grateful Patient™ Program, including
              processing fees, authorization fees, chargeback fees, or any other
              related expenses. Unless otherwise expressly agreed by The
              Foundation in writing, The Foundation shall not be responsible or
              liable for any such POS Fees, and all such POS Fees shall be the
              sole responsibility of Participant. This Section is not intended
              to amend preexisting written agreements in which The Foundation
              and Participant have agreed upon specific POS Fees. Participant
              may either (a) if available, acquire from one or more suppliers
              designated by The Foundation from time to time (each a “<strong
                >Designated Supplier</strong
              >”) specially configured equipment, software, and payment
              processing services (collectively, “<strong
                >Designated Supplier Equipment/Services</strong
              >”) or (b) use Participant’s own POS system.
              <strong
                >The Foundation does not warrant or endorse Designated Suppliers
                or Designated Supplier Equipment/Services and Participant’s use
                of any Designated Supplier Equipment/Services shall be at
                Participant’s own risk and subject to a separate agreement(s)
                between Participant and one or more Designated
                Suppliers.</strong
              >
              If Participant does not use Designated Supplier
              Equipment/Services, Participant shall: (i) create a separate stock
              keeping unit (“<strong>SKU</strong>”) to be used exclusively for
              POS Donations, (ii) allow customers to make a donation at checkout
              by any method of payment customarily accepted by Participant for
              purchases (but excluding private or public insurance and
              promotional coupons or offers); and (iii) issue a written receipt
              to the customer indicating the donation SKU number, the fact that
              the SKU represents a donation to OneSight EssilorLuxottica
              Foundation, the amount of the donation, and the date of the
              donation. With respect to all POS Donations collected by
              Participant, Participant shall deposit and safely and securely
              hold all such POS Donations as trustee for the sole benefit of The
              Foundation until they are remitted to The Foundation as provided
              in Section 6 (Payment) below; provided, that Participant shall not
              be required to maintain a segregated bank account for such POS
              Donations. The Foundation shall be the sole and exclusive owner of
              all POS Donations. Participant shall not use the POS Donations
              other than as described in this Grateful Patient™ Contract.
              Participant shall not allow the POS Donations to be assigned,
              alienated, pledged, encumbered or subjected to attachment,
              garnishment, levy, execution or other legal or equitable process
              by a third party.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
              "
            >
              <strong>Payment.</strong><strong>&#xa0;</strong>No later than
              thirty (30) days after the end of each month, Participant will
              remit to The Foundation 100% of the POS Donations collected by
              Participant during such month; provided, however, that Participant
              shall have no obligation to remit to The Foundation any POS
              Donations that cannot be processed (e.g., returned checks, credit
              card chargebacks, etc.) or that are remitted by Designated
              Suppliers. Payments shall be made in U.S. Dollars by (i) check
              payable to OneSight EssilorLuxottica Foundation and sent to The
              Foundation,<strong> </strong>P.O. Box 637509, Cincinnati, OH
              45263-7509; or (ii) electronic fund transfer (EFT) at Fifth Third
              Bank 38 Fountain Square Plaza – MD 1090U9 Cincinnati, OH 45263
              Routing #042000314 Account #7028939465; or (iii) online credit
              card payment at www.championsforsight.org/portal/resources or by
              using the custom link provided by The Foundation for online
              payments. Together with each payment, Participant shall provide to
              The Foundation an accounting of all POS Donations collected by
              Participant during the applicable
              <a name="_Hlk173322765"
                >period but excluding POS Donations remitted by Designated
                Suppliers</a
              >. Participant agrees that any tax credit or tax deduction accrues
              to the original donor and not to Participant, which is acting as a
              third-party conveyer of the donation. POS Donations may be used as
              The Foundation deems appropriate, in its sole discretion, in
              furtherance of The Foundation’s charitable mission.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
              "
            >
              <strong>Records. </strong>During the Term and for two (2) years
              thereafter, Participant shall (i) maintain complete and accurate
              books and records of all activities conducted in connection with
              the Grateful Patient™ Program and the collection and payment of
              all POS Donations, and (ii) allow The Foundation to inspect, copy,
              and/or audit such books and records.
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
              "
            >
              <strong>No Endorsement.</strong><strong>&#xa0;</strong>Participant
              shall in no way suggest endorsement by The Foundation of
              Participant or Participant’s products or services.
              <strong
                >The Foundation does not warrant or endorse Designated Supplier
                Equipment/Services and Participant’s use of any Designated
                Supplier Equipment/Services shall be at Participant’s own
                risk.</strong
              >
            </li>
            <li
              style="
                margin-left: 32.17pt;
                text-align: justify;
                line-height: normal;
                padding-left: 3.83pt;
              "
            >
              <strong>Permission to Link.</strong><strong>&#xa0;</strong>During
              the Term, The Foundation grants Participant permission to provide
              a link from Participant’s website to The Foundation’s website. The
              Foundation reserves the right to withdraw such permission at any
              time and for any reason.
            </li>
            <li
              style="
                margin-left: 36pt;
                text-align: justify;
                line-height: normal;
              "
            >
              <strong>Representations and Warranties of The Foundation</strong>.
              The Foundation represents and warrants to Participant that it: (i)
              has the right, power and authority to enter into this Grateful
              Patient™&#xa0; Contract; (ii) possesses sufficient rights to
              provide the Grateful Patient™&#xa0; Program Materials to
              Participant and authorize the Participant’s use of The Foundation
              Marks and the Grateful Patient™ Program Materials as set forth
              herein; and (iii) is a nonprofit organization in good standing and
              qualified for tax-exempt status under Section 501(c)(3) of the
              Internal Revenue Code.
            </li>
            <li
              style="
                margin-left: 36pt;
                text-align: justify;
                line-height: normal;
              "
            >
              <strong>Representations and Warranties of Participant</strong>.
              Participant represents and warrants to The Foundation that it: (i)
              has the right, power and authority to enter into this Grateful
              Patient™ Contract; and (ii) will comply with all applicable
              federal, state, and local laws, statutes, and regulations
              (collectively, “<strong>Laws</strong>”) in connection with the
              Grateful Patient™ Program and this Grateful Patient™ Contract,
              including any Laws governing charitable solicitations and
              fundraising.
            </li>
            <li
              style="
                margin-left: 36pt;
                text-align: justify;
                line-height: normal;
              "
            >
              <strong>Indemnity</strong>. Participant agrees to indemnify and
              hold The Foundation its directors, officers, employees, agents,
              and volunteers harmless from and against any and all costs, losses
              or expenses, including reasonable attorneys’ fees, that The
              Foundation may incur by reason of any claims, actions, demands, or
              law suits brought by a third party arising out of or in connection
              with (i) Participant’s negligence, recklessness, or intentional
              misconduct; (ii) Participant’s performance or failure to perform
              pursuant to this Grateful Patient™ Contract, including breach of
              any provision of this Grateful Patient™ Contract; or (iii)
              Participant’s location(s), business, products, or services,
              including any claims in the nature of product liability, personal
              injury, or professional malpractice.
            </li>
            <li
              style="
                margin-left: 36pt;
                text-align: justify;
                line-height: normal;
              "
            >
              <strong>Term and Termination. </strong>This Grateful Patient™
              Contract shall commence on the Effective Date and continue until
              terminated as provided herein (the “<strong>Term</strong>”).
              Either party may terminate this Grateful Patient™ Contract: (i)
              upon a material breach of the Grateful Patient™ Contract by the
              other party, if such breach is not remedied to the reasonable
              satisfaction of the non-breaching party within fifteen (15) days
              after the non-breaching party provides written notice of the
              breach to the other party; (ii) immediately upon written notice to
              the other party whenever the notifying party in its reasonable
              discretion determines that the continuation of the Grateful
              Patient™ Contract will damage its reputation or good will; (iii)
              upon fifteen (15) days written notice for convenience; or (iv)
              immediately upon written notice to Participant in the event The
              Foundation discontinues the Grateful Patient™ Program. Upon
              termination of this Grateful Patient™ Contract, Participant shall
              immediately convey to The Foundation all Grateful Patient™ Program
              Donations collected but not yet paid to The Foundation, cease to
              use the Grateful Patient™ Program Materials and The Foundation
              Marks, and discontinue references in any manner to its
              relationship with The Foundation. The provisions of this Section
              shall not preclude the parties from seeking any other remedies
              available to them under this Grateful Patient™ Contract and
              applicable law. The Sections regarding Payment, Records,
              Indemnity, Governing Law and Venue, Notices, and Miscellaneous
              shall survive termination of this Grateful Patient™ Contract. In
              addition, any provision which would, by its nature, survive the
              termination of this Grateful Patient™ Contract, shall do so.
            </li>
            <li
              style="
                margin-left: 36pt;
                text-align: justify;
                line-height: normal;
              "
            >
              <strong>Dispute Resolution; Governing Law and Venue</strong
              >.&#xa0;In the event of any dispute arising out of this Grateful
              Patient™ Contract, the parties shall use good faith efforts to
              resolve their differences amicably. In the event they are
              unsuccessful, the parties agree not to commence litigation until
              attempting to resolve their dispute through mediation. Any party
              may initiate the mediation process with thirty (30) days’ prior
              written notice to the other party. The dispute shall be submitted
              to mediation in New York, New York. Costs of mediation shall be
              borne equally by the parties.&#xa0; Mediation of the dispute shall
              be completed within fifteen (15) days of commencement, unless the
              parties extend the time by mutual agreement or unless the mediator
              declares the parties to be at an impasse. Notwithstanding the
              above, in the event that either party believes that immediate
              injunctive relief is required to protect its Marks or other
              intellectual property rights, such party may invoke the immediate
              powers of the appropriate court of law, subject to this Section
              15, without the requirement to first mediate the dispute. This
              Grateful Patient™ Contract shall be governed by and construed in
              accordance with the laws of the state of New York, without regard
              to conflicts of law principles. Any dispute arising out of or in
              connection with this Grateful Patient™ Contract that is not
              resolved under the dispute resolution provisions of this Section
              15 shall be filed and heard in the state or federal courts located
              in the State of New York, and each party consents to the exclusive
              jurisdiction of such courts.
            </li>
            <li
              style="
                margin-left: 36pt;
                text-align: justify;
                line-height: normal;
              "
            >
              <strong>Relationship of Parties.</strong
              ><strong>&#xa0;</strong>The parties to this Grateful Patient™
              Contract are not joint venturers, partners, agents, nor
              representatives of each other, are not authorized to act on each
              other’s behalf, and have no legal relationship other than as
              independent contracting parties to this Grateful Patient™
              Contract.
            </li>
            <li
              style="
                margin-left: 36pt;
                text-align: justify;
                line-height: normal;
              "
            >
              <strong>Assignment.</strong><strong>&#xa0;</strong>No party may
              assign this Grateful Patient™ Contract, or any rights or
              obligations hereunder, without the prior written consent of the
              other party. Notwithstanding the foregoing, in the event that any
              license agreement between The Foundation and its licensor is
              terminated, The Foundation may, without Participant’s consent,
              assign its rights and obligations with respect to any sublicense
              granted hereunder to such licensor. Any attempt to assign this
              Grateful Patient™ Contract in contravention of this Section shall
              be void and of no force and effect.
            </li>
            <li
              style="
                margin-left: 36pt;
                text-align: justify;
                line-height: normal;
              "
            >
              <strong>Notices.</strong><strong>&#xa0;</strong>All notices
              required or permitted to be given hereunder shall be in writing
              and shall be sent by (i) personal delivery, (ii) reputable courier
              service for prepaid overnight delivery, or (iii) USPS certified
              mail, postage prepaid, return receipt requested. All notices to
              Participant shall be forwarded to the contact person identified on
              the Registration Form at the address listed for Participant on the
              Registration Form or to such other person or address as
              Participant may designate in writing to The Foundation for this
              purpose. All notices to The Foundation shall be forwarded to
              OneSight EssilorLuxottica Foundation, Attn: Giving Team, P.O. Box
              637509, Cincinnati, OH 45263-7509 or to such other person or
              address as The Foundation may designate in writing to Participant
              for this purpose. In order for notice to The Foundation to be
              effective, a copy of such notice must be sent to The Foundation,
              Attn: General Counsel, at The Foundation address designated above.
              Notices delivered hereunder shall be effective when received or
              refused. Notwithstanding the foregoing, written approvals and
              authorizations required hereunder may be provided by facsimile,
              email, or other written means.
            </li>
            <li
              style="
                margin-left: 36pt;
                text-align: justify;
                line-height: normal;
              "
            >
              <strong>Entire Agreement.</strong><strong>&#xa0;</strong>This
              Grateful Patient™ Contract supersedes any prior understandings or
              oral agreements between the parties regarding the subject matter
              hereof and constitutes the entire understanding and agreement of
              such parties with respect to the subject matter hereof.
              Notwithstanding the foregoing, your use of the OneSight
              EssilorLuxottica Foundation website is also subject to the Terms
              of Use (<a
                href="http://www.championsforsight.org/terms-of-use"
                style="text-decoration: none"
                ><u
                  ><span style="color: #467886"
                    >www.championsforsight.org/terms-of-use</span
                  ></u
                ></a
              >) and Privacy Policy (<a
                href="http://www.championsforsight.org/privacy-policy"
                style="text-decoration: none"
                ><u
                  ><span style="color: #467886"
                    >www.championsforsight.org/privacy-policy</span
                  ></u
                ></a
              >) posted on the Champions of Site website portal; provided, that
              in the event of any conflict between this Grateful Patient™
              Contract and the Terms of Use and/or Privacy Policy, the
              provisions of this Grateful Patient™&#xa0; Contract shall prevail.
            </li>
            <li
              style="
                margin-left: 36pt;
                text-align: justify;
                line-height: normal;
              "
            >
              <strong>Non-Exclusivity.</strong><strong>&#xa0;</strong>This
              Grateful Patient™ Contract is a non-exclusive agreement which
              reserves the rights of the parties to contract with third parties
              for similar transactions.
            </li>
            <li
              style="
                margin-left: 36pt;
                margin-bottom: 8pt;
                text-align: justify;
                line-height: 108%;
              "
            >
              <strong>Miscellaneous.</strong><strong>&#xa0;</strong>The failure
              of any party at any time to require performance of any provision
              of, or resort to any remedy provided under, this Grateful Patient™
              Contract shall in no way affect the right of that party to require
              performance or resort to a remedy at any time thereafter, nor
              shall the waiver by any party of a breach be deemed to be a waiver
              of any subsequent breach. A waiver shall not be effective unless
              it is in writing and signed by the party against whom the waiver
              is being enforced. If any term or provision of this Grateful
              Patient™ Contract is determined to be invalid, illegal, or
              incapable of being enforced by any law, regulation, or public
              policy, all other terms and provisions of this Grateful Patient™
              Contract shall nevertheless remain in full force and effect. This
              Grateful Patient™ Contract shall not be altered, amended or
              modified in any way except by a written instrument dated
              subsequent to the date of this Grateful Patient™ Contract and
              signed on behalf of the parties by their respective duly
              authorized representatives. Section captions and headings are for
              are for reference purposes only and shall not control or affect
              the construction or interpretation of this Grateful Patient™
              Contract in any respect. The word “including” means “including,
              but not limited to.”
            </li>
          </ol>
        </div>
        <div class="radio">
          <label>
            <input
              v-on:click="EnableTermAndAgreementSubmitBtn(4, false)"
              type="radio"
              v-model="Account.TermAgreement"
              value="true"
              name="TermAgreement"
            />
            I have read and AGREE to all of the above
            <ol type="I">
              <li>
                <a
                  href="https://files.championsforsight.org/CLTLTermsAndConditions1024.pdf"
                  target="_blank"
                >
                  Terms and Conditions to the Changing Life through Lenses®
                  Agreement
                </a>
              </li>
              <li>
                <a
                  href="https://files.championsforsight.org/BusinessAssociateAgreement1024.pdf"
                  target="_blank"
                >
                  Business Associate Agreement (BAA) </a
                >(collectively, the "Contract")
              </li>
              <li>
                <a
                  href="https://files.championsforsight.org/GratefulPatients1024.pdf"
                  target="_blank"
                >
                  Terms and Conditions to Point of Sale Giving
                </a>
              </li>
            </ol>
          </label>
        </div>
        <div class="radio">
          <label>
            <input
              v-on:click="EnableTermAndAgreementSubmitBtn(4, true)"
              type="radio"
              v-model="Account.TermAgreement"
              value="false"
              name="TermAgreement"
            />
            I DO NOT AGREE to all the above
          </label>
        </div>
        <!-- REAL TIME VALIDATION -->
        <p
          v-if="
            agreementOptions.termsAndCondition[4] &&
            Account.TermAgreement != null
          "
          class="error-message"
        >
          You must select "I Agree" to submit the form. Please click
          <a v-on:click="ShowModalTAC()">here</a> to contact us with questions
          or concerns
        </p>
        <div v-if="isModalShownTAC">
          <portal-form @closeWufoo="CloseModal()"></portal-form>
        </div>
      </div>
      <div hidden class="col-lg-12 col-md-12 col-sm-12 col-xs-12 feed-back-div">
        <p>
          By selecting, “I DO NOT AGREE”, you will not be able to complete your
          registration for a portal account. If you have any questions or
          concerns, please send us an email below.
        </p>
        <div class="form-group">
          <label>Name*</label>
          <input type="text" class="form-control" v-model="TermsEmail.Name" />
        </div>
        <div class="form-group">
          <label>Email Address*</label>
          <input type="text" class="form-control" v-model="TermsEmail.Email" />
        </div>
        <div class="form-group">
          <label>Please Enter Message Below*</label>
          <textarea
            class="form-control"
            v-model="TermsEmail.Message"
          ></textarea>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 email_box_btn">
            <button
              class="evf-button"
              type="submit"
              v-on:click="SubmitEmail(1)"
            >
              Send
            </button>
          </div>
        </div>
      </div>
      <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
        <div class="form-group">
          <label>Electronic Signature*</label>
          <input
            type="text"
            v-model="Account.ParticipantResponsibilitiesSignature"
            v-bind:class="{
              error_field:
                AccountValidationResult.AccountParticipantResponsibilitiesSignature,
            }"
            class="form-control"
          />
          <p
            class="error-message"
            v-if="
              AccountValidationResult.AccountParticipantResponsibilitiesSignature
            "
          >
            {{
              AccountValidationResult.AccountParticipantResponsibilitiesSignature
            }}
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
        <div class="form-group">
          <label>Date*</label>
          <input
            v-model="Account.ParticipantResponsibilitiesDate"
            class="form-control"
            readonly
          />
        </div>
      </div>
      <div
        v-if="
          Account.IsCoveredUnderHIPAA == true ||
          Account.IsCoveredUnderHIPAA == null
        "
        class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
      >
        <!-- <div class="section_div">
                    <img src="../../../static/img/section_divider.png" class="divider_img">
                </div> -->

        <div v-if="isModalShownBAA">
          <portal-form @closeWufoo="CloseModal()"></portal-form>
        </div>
        <!-- REAL TIME VALIDATION -->
        <p
          v-if="
            agreementOptions.termsAndCondition[5] &&
            Account.BusinessAssociateAgreement != null
          "
          class="error-message"
        >
          You must select "I Agree" to submit the form. Please click
          <a v-on:click="ShowModalBAA()">here</a> to contact us with questions
          or concerns
        </p>
        <div
          hidden
          v-if="Account.BusinessAssociateAgreement == false"
          class="col-lg-12 col-md-12 col-sm-12 col-xs-12 feed-back-div"
        >
          <p>
            By selecting, “I DO NOT AGREE”, you will not be able to complete
            your registration for a portal account. If you have any questions or
            concerns, please send us an email below.
          </p>
          <div class="form-group">
            <label>Name*</label>
            <input
              type="text"
              class="form-control"
              v-model="BusinessEmail.Name"
            />
          </div>
          <div class="form-group">
            <label>Email Address*</label>
            <input
              type="text"
              class="form-control"
              v-model="BusinessEmail.Email"
            />
          </div>
          <div class="form-group">
            <label>Please Enter Message Below*</label>
            <textarea
              class="form-control"
              v-model="BusinessEmail.Message"
            ></textarea>
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 email_box_btn">
              <button
                class="evf-button"
                type="submit"
                v-on:click="SubmitEmail(2)"
              >
                Send
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
        <p
          class="error-message"
          v-if="
            AccountValidationResult.AccountIsCoBrandAgreed ||
            AccountValidationResult.AccountIsElectronicLogAgreed ||
            AccountValidationResult.AccountIsLensesAgreementAgreed ||
            AccountValidationResult.AccountIsPatientChargeAgreed ||
            AccountValidationResult.AccountIsValidatePatientNeedAgreed
          "
        >
          Please accept all agreements
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import PortalForm from "@/components/shared/PortalForm";
export default {
  props: [
    "Account",
    "AccountValidationResult",
    "FormInputs",
    "BusinessEmail",
    "TermsEmail",
  ],
  components: { PortalForm },
  data() {
    return {
      isModalShown: false,
      isModalShownTAC: false,
      isModalShownBAA: false,
      agreementOptions: {
        termsAndCondition: [true, true, true, true, true, true],
      },
      termsAndConditionError: 'You must select "I Agree" to submit the form',
      termsAndConditionError2:
        'You must select "I Agree" to submit the form.  Please click here to contact us with questions or concerns',
    };
  },
  methods: {
    SubmitEmail(ind) {
      var email = null;
      if (ind == 1) {
        email = this.TermsEmail;
      } else if (ind == 2) {
        email = this.BusinessEmail;
      }
      axios
        .post("/Account/SendFeedback", email)
        .then((response) => {
          console.log("success");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    ShowModal() {
      document.body.classList.add("body-overflow");
      this.isModalShown = !this.isModalShown;
    },
    ShowModalBAA() {
      document.body.classList.add("body-overflow");
      this.isModalShownBAA = !this.isModalShownBAA;
    },
    ShowModalTAC() {
      document.body.classList.add("body-overflow");
      this.isModalShownTAC = !this.isModalShownTAC;
    },
    EnableTermAndAgreementSubmitBtn(index, value) {
      this.agreementOptions.termsAndCondition[index] = value;
    },
    CloseModal() {
      this.isModalShown = false;
      this.isModalShownTAC = false;
      this.isModalShownBAA = false;
      document.body.classList.remove("body-overflow");
    },
  },
};
</script>



// WEBPACK FOOTER //
// TermAgreementAndBaa.vue?21b9b98d